// extracted by mini-css-extract-plugin
export default {"heading-primary":"Spinner_heading-primary__k50R+","loader":"Spinner_loader__+JXEg","rotation":"Spinner_rotation__eJBdM"};